import { render, staticRenderFns } from "./cybfooter.vue?vue&type=template&id=abfdfbe8&"
import script from "./cybfooter.vue?vue&type=script&lang=js&"
export * from "./cybfooter.vue?vue&type=script&lang=js&"
import style0 from "./cybfooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports